import type { LocalesValues } from 'intlayer'
import { atom } from 'jotai'
import { atomWithSuspenseQuery } from 'jotai-tanstack-query'
import { type StoreLookupProduct, StoreLookupProductSchema } from '@/models/lookup.dto'

export const localeAtom = atom<LocalesValues>('ja')

export const productsAtom = atomWithSuspenseQuery((get) => {
  const locale = get(localeAtom)
  return {
    queryKey: ['products', locale],
    queryFn: async (): Promise<StoreLookupProduct[]> => {
      const filename = locale === 'ja' ? 'jp.json' : 'us.json'
      const response = await fetch(`/products/${filename}`)

      if (!response.ok) {
        throw new Error(`商品データの取得に失敗したよ: ${response.status}`)
      }
      return StoreLookupProductSchema.array().parse(await response.json())
    }
  }
})
